import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const HomeContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HomeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HomeIcon = styled.div`
  width: 67px;
  height: 67px;
  background: ${colors.bgTertiary};
  border-radius: 16px;
  box-shadow: 0px 5px 10px ${colors.bgTertiaryShadow};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HomeTitle = styled.p`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  margin-top: 20px;
  color: ${colors.textPrimary};
`;

export const HomeParapraph = styled.p`
  font-size: 16px;
  line-height: 23px;
  margin-top: 20px;
  color: ${colors.textPrimary};
`;

export const HomeFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  button:first-child {
    margin-right: 20px;
  }
`;
